import { render } from "./InputRange.vue?vue&type=template&id=8bf8a676"
import script from "./InputRange.vue?vue&type=script&lang=js"
export * from "./InputRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__